import { LIVEKIT, TWILIO, ZOOM } from 'constants/vendors'
import { MIN_FACE_DETECTION_CONFIDENCE } from 'constants/vignette'

export async function createVideoService(vendor, connectOptions) {
  let faceDetector

  // for Zoom SDK face detector is initialized inside worker VignetteProcessor.worker.js
  if (connectOptions.showVignette && vendor !== ZOOM) {
    faceDetector = await createFaceDetector()
  }
  const options = faceDetector ? {...connectOptions, faceDetector} : connectOptions

  switch (vendor) {
    case TWILIO:
      const { default: TwilioVideoService } = await import('./TwilioVideoService')
      return new TwilioVideoService(options)
    case LIVEKIT:
      const { default: LiveKitVideoService } = await import('./LiveKitVideoService')
      return new LiveKitVideoService(options)
    case ZOOM:
      const { default: ZoomVideoService } = await import('./ZoomVideoService')
      return new ZoomVideoService(options)
    default:
      const { default: TwilioVideoServiceDefault } = await import('./TwilioVideoService')
      return new TwilioVideoServiceDefault(options)
  }
}

async function createFaceDetector() {
  const mediaPipe = await import('@mediapipe/tasks-vision')
  const FaceDetector = mediaPipe.FaceDetector
  const FilesetResolver = mediaPipe.FilesetResolver

  const vision = await FilesetResolver.forVisionTasks(
    'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm'
  )
  return await FaceDetector.createFromOptions(vision, {
    baseOptions: {
      modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite',
      delegate: 'GPU'
    },
    runningMode: 'IMAGE',
    minDetectionConfidence: MIN_FACE_DETECTION_CONFIDENCE
  })
}
